// Font Awesome CDN and Google Analytics
export const onClientEntry = () => {
  // Font Awesome CDN
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css'
  document.head.appendChild(link)

  // Google Analytics (gtag.js)
  const gtagScript = document.createElement('script')
  gtagScript.async = true
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-0GCSP467BF'
  document.head.appendChild(gtagScript)

  window.dataLayer = window.dataLayer || []
  function gtag(){dataLayer.push(arguments)}
  gtag('js', new Date())
  gtag('config', 'G-0GCSP467BF')
}